// 앱(Play 스토어 TWA·홈 화면 설치 PWA) 전용 강의 상세 이동(2026-10-07).
// 웹은 카드 클릭 시 상세를 새 탭으로 열어 검색 탭이 그대로 남지만, 앱엔 탭이 없어 같은 방식이면
// 검색 상태(태그·스크롤·랜덤 결과)가 날아간다. 그래서 앱에선 상세를 pushState로 열고 App.tsx가
// 검색 화면을 언마운트하지 않은 채 그 위에 오버레이로 띄운다 — 뒤로가기/"검색으로 돌아가기"면
// 오버레이만 닫혀 검색 화면이 그대로 보인다.

/** index.tsx가 TWA 실행을 감지해 sessionStorage에 남기는 키 */
export const APP_SESSION_KEY = "starinfo_app";

type LectureNavState = {
  /** 이 엔트리가 검색 화면에서 몇 번째로 쌓인 상세인지 */
  lectureDepth: number;
  /** 첫 상세가 검색 화면에서 열렸는지(아래에 검색 화면이 살아 있는지) */
  overSearch: boolean;
};

export function isAppMode(): boolean {
  try {
    if (sessionStorage.getItem(APP_SESSION_KEY) !== null) return true;
  } catch {}
  try {
    return window.matchMedia("(display-mode: standalone)").matches;
  } catch {
    return false;
  }
}

export function getLectureNavState(state: unknown = window.history.state): LectureNavState | null {
  const s = state as Partial<LectureNavState> | null;
  return s && typeof s.lectureDepth === "number" ? { lectureDepth: s.lectureDepth, overSearch: !!s.overSearch } : null;
}

/** 페이지 이동 없이 상세로 — pushState는 popstate를 안 쏘므로 App.tsx가 알 수 있게 직접 발생시킴 */
export function pushLecture(path: string): void {
  const prev = getLectureNavState();
  const next: LectureNavState = prev
    ? { lectureDepth: prev.lectureDepth + 1, overSearch: prev.overSearch }
    : { lectureDepth: 1, overSearch: !/\/lecture\//.test(window.location.pathname) };
  window.history.pushState(next, "", path);
  window.dispatchEvent(new PopStateEvent("popstate", { state: next }));
}

/** 앱 모드면 상세를 오버레이로, 아니면 기존 방식(웹: 새 탭) 그대로 */
export function openLecture(path: string, webFallback: () => void): void {
  if (isAppMode()) pushLecture(path);
  else webFallback();
}

/** 쌓인 상세를 한 번에 걷어내 검색 화면으로. 처리했으면 true(링크 기본 이동을 막아야 함) */
export function backToSearch(): boolean {
  const s = getLectureNavState();
  if (!s || !s.overSearch) return false;
  window.history.go(-s.lectureDepth);
  return true;
}
